export default "/assets/weekly-photos-block-female-placeholder.png";